import { useEffect, useState } from 'react'
import { SheetsData } from './CategoriesToExplore'
interface Props {
    handleOpen: () => void;
    handleItemClick: (_id: string | null, name: string | null) => void;
    sheets:SheetsData[]
}
const SheetsSection = ({ handleOpen,handleItemClick,sheets }: Props) => {

    return (
        <>
            <div className="px-4 mt-8 mb-3">
                <div className="flex items-center justify-between mb-1">
                    <div className="flex items-center gap-2 flex-1">
                        <h4 className="text-[17px] font-semibold text-black/80 whitespace-nowrap">
                            Sheets
                        </h4>
                        <div className="border-t border-dashed border-gray-400 flex-1"></div>
                    </div>
                    <button onClick={handleOpen} className="text-[10px] px-5 py-1 border border-gray-300 rounded-full bg-white hover:bg-gray-100 transition whitespace-nowrap ml-2 ">
                        View
                    </button>
                </div>

                <p className="text-[12px] text-gray-600 mb-2">
                    High-quality metal and roofing sheets available in various
                    materials and finishes.
                </p>

                <div className="grid grid-cols-5 gap-2 text-xs text-gray-700 h-[300px]">
                    <div className="col-span-3 flex flex-col gap-2 h-full">
                        <div className="flex-[3] border-2  shadow-sm rounded-md p-2 overflow-hidden flex justify-center items-center"
                        onClick={() => handleItemClick(sheets[0]?.categoryId, sheets[0]?.categoryName)}
                        >
                            <img
                                className="object-contain"
                                src={sheets[0]?.images[0]}
                                alt=""
                            />
                        </div>
                        <div className="flex-[2] border-2  shadow-sm flex justify-center items-center rounded-md p-2 overflow-hidden"
                        onClick={() => handleItemClick(sheets[1]?.categoryId, sheets[1]?.categoryName)}
                        >
                            <img
                                className="object-contain max-h-[100px]"
                                src={sheets[1]?.images[0]}
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="col-span-2 flex flex-col gap-2 h-full">
                        <div className="flex-[2] border-2  shadow-sm flex justify-center items-center  rounded-md p-2 overflow-hidden"
                        onClick={() => handleItemClick(sheets[2]?.categoryId, sheets[2]?.categoryName)}
                        >
                            <img
                                className="object-contain"
                                src={sheets[2]?.images[0]}
                                alt=""
                            />
                        </div>
                        <div className="flex-[3] shadow-sm flex justify-center items-center border-2  rounded-md p-2 overflow-hidden"
                        onClick={() => handleItemClick(sheets[3]?.categoryId, sheets[3]?.categoryName)}
                        >
                            <img
                                className="object-contain"
                                src={sheets[3]?.images[0]}
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SheetsSection